import styled from "styled-components";
import { useAppSelector } from "../../hooks";
import { AcceptingOrdersMessage, OrderTypeSwitch } from "@tiffin/components";
import EnvironmentOutlined from "@ant-design/icons/EnvironmentOutlined"
import ShopOutlined from "@ant-design/icons/ShopOutlined"
import { OrderType, SubscriptionPlan } from "@tiffin/core";
import { useSearchParams } from "react-router-dom";
import { Modal } from "antd";
import { TablePicker } from "./TablePicker";
import { useState } from "react";

export const HomeHeader = styled(BaseHomeHeader)`

  background: #000;
  min-height: 200px;
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr;

  &.dinein {
    min-height: 180px;
  }

  .cover-image {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: cover;
    opacity: 0.6;
  }

  .store-heading {
    color: #fff;
    font-weight: 600;
    font-size: 3em;
    padding: 10px 40px;
    display: grid;
    grid-template-columns: auto 1fr;
    opacity: 1;
    position: relative;
    align-items: center;
    gap: 20px;

    .store-logo {
      height: 100px;
      width: 100px;
    }

    .store-title {
      @media (min-width:768px) {
        text-align: right;
      }
    }
  }

  .store-subheading {
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    gap: 10px;


    .table-number {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;
    
      background: rgba(0,0,0,0.7);
      border-radius: 7px;
      color: #fff;
      font-weight: 600;
    
      z-index: 1;
      padding: 10px 20px;
      margin: auto 0px;
      cursor: pointer;
    }

    .order-type {
      margin: auto 0px;
      width: 240px;
      height: 40px;
      background: rgba(0,0,0,0.7);
      color: #fff;

      .segment-button-checked {
        color: #000;
      }
    }

    .single-order-type {
      background: rgba(0,0,0,0.7);
      color: var(--color-light);
      font-weight: 600;
      z-index: 1;
      padding: 10px 20px;
      border-radius: 7px;
      margin: auto 0;
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }

  @media (max-width:768px) {
    width: 100vw;
    min-height: unset;
    max-height: 2560px;
    grid-template-rows: auto 1fr;

    .store-heading {
      justify-content: flex-start;
      padding: 20px 20px 0;
    }

    &.dinein {
      min-height: unset;
    }

    .store-subheading {
      display: flex;
      gap: 10px;
      padding: 20px;
      flex-wrap: wrap;

      .order-type-switch {
        grid-row: 2;
      }
    }
  }

`

interface IHomeHeader {
  className?: string
}

function BaseHomeHeader({className}: IHomeHeader) {

  const [openTablePicker, setOpenTablePicker] = useState(false)
  const partner = useAppSelector((state) => state.store)
  const cart = useAppSelector((state) => state.cartMulti.carts[partner.details!.id]);
  const cartStatus = useAppSelector((state) => state.cartMulti.status)
  const [searchParams] = useSearchParams();
  let tableNumber = searchParams.get("table");

  const staticPlan = partner.details?.subscriptionPlan === SubscriptionPlan.StarterMonthly || partner.details?.subscriptionPlan === SubscriptionPlan.StarterAnnual
  
  return (
    <>
      {
        partner.details && cart &&
        <div className={`${className} ${cart.orderType === OrderType.DineIn ? 'dinein' : ''}`}>
          <div className="cover-image" style={{backgroundImage: `url(${partner.details.imageUrl})`  ?? `url(${process.env.PUBLIC_URL}/assets/images/default-cover.jpg)`}}></div>
          <div className="store-heading" style={{justifyContent: partner.details.logoImageUrl ? 'space-between' : 'flex-end'}}>
            {
              partner.details.logoImageUrl &&
              <div className="store-logo">
                <img alt="logo" className="fadeOut" src={partner.details.logoImageUrl} onLoad={(e) => e.currentTarget.classList.add("fadeIn")}/>
              </div>
            } 
            <span className="store-title">
              {partner.details?.name}
            </span>
          </div>
    
          <div className="store-subheading">
            {
              (!staticPlan && cart.orderType !== OrderType.DineIn) &&
              <>
                {
                  (partner.details.offerPickup && partner.details.offerDelivery) ?
                  <OrderTypeSwitch
                    className="order-type"
                    isPartnerWebsite={true}
                    partner={partner.details}
                    cart={cart}
                    cartStatus={cartStatus}
                  />
                  :
                  <div className="single-order-type">
                    {
                      partner.details.offerPickup &&
                      <>
                        <ShopOutlined /> 
                        <span>Only accepting pickup orders</span>
                      </>
                    }
                    {
                      partner.details.offerDelivery &&
                      <>
                        <EnvironmentOutlined /> 
                        <span>Only accepting delivery orders</span>
                      </>
                    }
                  </div>
                }
              </>
            }
            {
              cart.orderType === OrderType.DineIn &&
              <div className="table-number" onClick={() => setOpenTablePicker(true)}>Table {tableNumber}</div>
            }
            <AcceptingOrdersMessage cart={cart} partner={partner.details} />
          </div>
          <Modal
            title="Please select a table"
            open={openTablePicker}
            onCancel={() => setOpenTablePicker(false)}
            footer={[]}
          >
            <div style={{paddingTop: "10px"}}>
              <TablePicker />
            </div>
          </Modal>
        </div>
      }
    </>
  )
}